import React from 'react'
import {
  CFImage,
  CFLink,
  CFView,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { yelp, facebook, instagram, zomato } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView mv="20px" column center>
          <CFView h3 futura bold color="#F8611A" mb="20px">
            SOCIAL MEDIA
          </CFView>
          <CFView row center white bold>
            <CFLink
              target="_blank"
              href="https://www.facebook.com/pages/category/Breakfast---Brunch-Restaurant/Kooks-Cooks-110389023943267/"
            >
              <CFImage
                w="45px"
                pr="10px"
                src={facebook}
                alt="Kooks Cooks Facebook"
                hover
              />
            </CFLink>
            <CFLink href="https://www.instagram.com/kooks.cooks/?hl=en">
              <CFImage
                w="45px"
                pr="10px"
                src={instagram}
                alt="Kooks Cooks Instagram"
                hover
              />
            </CFLink>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView mb="13px" mt="15px" column justifyStart>
          <CFView h3 futura bold color="#F8611A" mb="15px">
            SOCIAL MEDIA
          </CFView>
          <CFView row justifyStart alignCenter white bold>
            <CFLink
              target="_blank"
              href="https://www.facebook.com/pages/category/Breakfast---Brunch-Restaurant/Kooks-Cooks-110389023943267/"
            >
              <CFImage
                w="45px"
                pr="10px"
                src={facebook}
                alt="Kooks Cooks Facebook"
                hover
              />
            </CFLink>
            <CFLink href="https://www.instagram.com/kooks.cooks/?hl=en">
              <CFImage
                w="45px"
                pr="10px"
                src={instagram}
                alt="Kooks Cooks Instagram"
                hover
              />
            </CFLink>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
